import { gql } from 'apollo-angular';

export const contact = gql`
	fragment Contact on ContactOutput {
		id
		name
		ownerId
		language
		companies
		categories
		phoneNumber
		emailAddress
		updateTimestamp
		creationTimestamp
		lastMeetingTimestamp
		modulesColumn {
			columnId
			moduleId
		}
		notes {
			taskId
			note
		}
	}
`;
